import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const Container = styled.div<LayoutProps & SpaceProps>`
  background-color: ${tokens.colors.black};
  width: 100%;
  height: 500px;
  position: relative;
  box-sizing: content-box;

  ${layout};
  ${space};
`;

export const Background = styled.img`
  object-fit: cover;
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  padding: 0 ${tokens.space.regular};
  box-sizing: border-box;

  ${tokens.mediaQueries.s} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
